import { NativeBridgeError, NativeBridgeResponse } from 'scbk-services/types/bridge/global';
import { useNativeBridgeCallbackRegistryStore } from '../stores/nativeBridgeCallbackRegistry';

/**
 * 네이티브 브릿지 콜백 수신 처리
 */
const NativeBridgeReceiver = {
    /**
     *
     * @param responseJson 네이티브 응답 JSON 문자열
     * @returns
     */
    onNativeBridgeCallback(responseJson: string) {
        const { hasCallback, invokeCallback, unregisterCallback } =
            useNativeBridgeCallbackRegistryStore.getState();
        if (responseJson === null || responseJson === '') {
            console.log('# [NativeBridgeReceiver] empty response from native');
            return null;
        }

        console.log('# NativeBridgeReceiver.onNativeBridgeCallback responseJson', responseJson);

        const parseJson = safeParseJson<unknown>(responseJson);
        if (!parseJson) {
            return;
        }
        const response = parseJson as NativeBridgeResponse<unknown>;
        const { requestId, status } = response;

        //payload만
        let payload;
        let error;

        if (status === 'fail' || status === 'error') {
            if (typeof response.error === 'string') {
                error = JSON.parse(response.error || {}) as NativeBridgeError;
            } else {
                error = (response.error ?? {}) as NativeBridgeError;
            }
        } else {
            if (typeof response.payload === 'string') {
                try {
                    payload = JSON.parse(response.payload || '{}');
                } catch (e) {
                    console.warn(
                        '[NativeBridgeReceiver] payload JSON parse 실패',
                        response.payload,
                    );
                    payload = {};
                }
            } else {
                payload = response.payload ?? {};
            }

            if (!hasCallback(requestId)) {
                console.warn(
                    `# [NativeBridgeReceiver] 등록된 callback 함수가 없음, command: ${requestId}`,
                    ``,
                );
                return;
            }
        }

        let isErrored = false;
        try {
            //콜백함수 실행
            invokeCallback(requestId, {
                ...response,
                payload,
                error: status !== 'success' ? error : undefined,
            });
        } catch (e) {
            console.log('#NativeBridgeReceiver.onNativeBridgeCallback error', e);
            isErrored = true;
        } finally {
            //콜백 함수
            if (isErrored && unregisterCallback) {
                unregisterCallback(requestId);
            }
        }
    },
};

/**
 *
 * @param raw
 * @returns
 */
function safeParseJson<T extends unknown>(raw: string): T | null {
    try {
        return JSON.parse(raw);
    } catch (e) {
        console.error(`[NativeBridgeReceiver] JSON parse error:`, e, `\nraw={${raw}}`);
        return null;
    }
}

/**
 * 네이티브 브릿지 콜백 함수 리시버 등록
 * [2026.02.12 최성돈 수정] window.nativeBridge 초기화 시 onNativeBridgeCallback 함수로 덮어지는 문제 해결
 */
function registerNativeBridgeReceiver() {
    (window as any).onNativeBridgeCallback = function (responseJson: string) {
        NativeBridgeReceiver.onNativeBridgeCallback(responseJson);
    };
}

/**
 * 네이티브 백키 제어 함수 등록
 * @param callback
 */
function registerNativeBackPressed(callback: () => void) {
    ((window as any).onNativeBridgeCallback ??= {}).doWBack = function () {
        if (callback) {
            console.log('### back callback : ', callback);
            callback();
        }
    };
}

/**
 * 네이티브 백키 제어 함수 해제
 * @param callback
 */
function unregisterNativeBackPressed() {
    delete (window as any).onNativeBridgeCallback?.doWBack;
}

export { registerNativeBackPressed, registerNativeBridgeReceiver, unregisterNativeBackPressed };
